import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { ventilationExtractionLp } from "@/content/landing/ventilation-extraction";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";
import { SERVICE_PAGE_OG_IMAGES } from "@/lib/service-page-og-images";

const LpVentilationExtractionPage = lazyNamed(
  () => import("@/components/landing/lp-ventilation-extraction"),
  "LpVentilationExtraction",
);

const PATH = "/ventilation-extraction";
const TITLE = "Ventilation & Extraction South Wales | PAS 2030 | CRS Energy";
const DESCRIPTION =
  "Whole-house ventilation strategy across South Wales. PAS 2030 Certified, insurance-backed guarantee, inspection-led. Reduce condensation, humidity and stale air. Free assessment.";

export const Route = createFileRoute("/ventilation-extraction")({
  head: () =>
    withServiceLcpPreload(PATH, {
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      image: SERVICE_PAGE_OG_IMAGES[PATH],
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: "Ventilation & Extraction",
        description: DESCRIPTION,
        serviceType: "Ventilation & Extraction",
        url: `${SITE.url}${PATH}`,
        image: SERVICE_PAGE_OG_IMAGES[PATH],
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: ventilationExtractionLp.faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  }),
  component: LpVentilationExtractionPage,
});
